import queryString from "query-string";
import { endpoints } from "../../User/Constants/endpoints";
import { ApiRequest } from "../../Common";
import ResponseHandler from "../../App/ResponseHandler";
import { UserAutocompleteItem } from "../../Layout/Models/AutocompleteItem";
import { UserAutocompleteItemDto } from "../Components/Common/CommentBox/PingUserAutocompleteItem";
import { ResponseResult } from "../../Common/Models/ResponseResult";
import { commentRestrictions } from "../Constants/commentRestrictions";

function assembleAutocompleteUrl(
  query: string,
  maxToGet: number,
  allowUsersFromOtherCompanies: boolean
): string {
  let url: string = endpoints.search.autocomplete();

  const queryArgs = {
    query,
    maxSuggestionsToGet: maxToGet,
    AllowUsersFromOtherCompanies: allowUsersFromOtherCompanies
  };

  const stringified = queryString.stringify(queryArgs);

  url += `?${stringified}`;

  return url;
}

export function makeCommentPingAutocompleteProvider(allowUsersFromOtherCompanies: boolean) {
  return function commentPingAutocompleteProvider(token: string) {
    return ApiRequest.fromPath(
      assembleAutocompleteUrl(
        token,
        commentRestrictions.maxPingSuggestions,
        allowUsersFromOtherCompanies
      )
    )
      .withAuthHeader()
      .get()
      .then((response: Response) => {
        return response.json();
      })
      .then((items: ResponseResult) => {
        // convert these to the right format
        return items.payload.map(
          (item: UserAutocompleteItem): UserAutocompleteItemDto => ({
            name: item.itemName,
            companyName: item.companyName,
            code: item.code,
            isOtherCompany: item.isOtherCompany
          })
        );
      });
  };
}
